import oRequest from "@/path";
import oStorage from '@/libsV2/storage.js';
import {Toast} from "mint-ui";


/**
 * 案例分享数据
 * @param  tp5xcxuserid
 */
export const fetchEnterpriseTotal = (tp5xcxuserid) => {
    return new Promise((resolve, reject) => {
        //2.0
        // oRequest.post5('project/index/enterpriseTotal',{tp5xcxuserid}).then(res => {
        //3.0
        oRequest.post5('project/v3/enterprise/total', {tp5xcxuserid}).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
/**
 * 案例阅读数据
 * @param  tp5xcxuserid
 */
export const fetchPrivewTotal = (tp5xcxuserid) => {
    return new Promise((resolve, reject) => {
        //2.0
        // oRequest.post5('project/index/enterpriseview', {tp5xcxuserid}).then(res => {
        //3.0
        oRequest.post5('project/v3/enterprise/enterpriseView', {tp5xcxuserid}).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
/**
 * 口碑分享数据
 * @param  tp5xcxuserid
 */
export const fetchShareTotal = (options) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/discuss/enterpriseTotal', options).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
/**
 * 口碑阅读数据
 * @param  tp5xcxuserid
 */
export const fetchViewTotalC = (tp5xcxuserid, sources = '') => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/discuss/enterpriseView', {user_id: tp5xcxuserid, sources}).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}

/**
 * 案例/口碑触达数据
 * @param  tp5xcxuserid
 * @param  is_priase 区分口碑(1)和全部(0)案例
 */
export const getReachDataTotal = (tp5xcxuserid, is_priase = 0) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/v3/track/reach', {tp5xcxuserid, is_priase}).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
/**
 * 案例/口碑 成交&成交额 数据
 * @param  tp5xcxuserid
 * @param  is_priase 区分口碑(1)和全部(0)案例
 */
export const getTurnoverDataTotal = (tp5xcxuserid, is_priase) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/v3/track/moa', {tp5xcxuserid, is_priase}).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}

export const fetchViewAuthor = (tp5xcxuserid) => {
    return new Promise((resolve, reject) => {
        console.log(tp5xcxuserid, 'tp5xcxuserid')
        oRequest.post5('project/discuss/checkAuth', {user_id: tp5xcxuserid || JSON.parse(oStorage.getStorage('user_id')).data}).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
// /**
//  * @interface 获取排行参数
//  */
// const  FetchEnterpriseRank = {
//     type: string, // 排行类型
//     region_Id: number | string, // 大区id 多个用英文逗号分隔
//     office_Id: number | string, // 办事处id 多个用英文逗号分隔
//     start_date: string, // 开始时间
//     end_date: string, // 结束时间
//     attr: string, // 人员属性 ao ：ao人员；dl ：代理商人员 ，多个用英文逗号分隔
//     order: {
//         total_desc: 1 | 0, // 总数升序 0：否；1：是
//         total_asc: 1 | 0, // 总数降序 0：否；1：是
//     } //排序
// };

/**
 * 获取分享排行
 * @param  option 获取排行参数
 */
export const fetchEnterpriseRank = (option) => {
    return new Promise((resolve, reject) => {
        //2.0
        // oRequest.post5('project/index/enterpriseRank', option).then(res => {
        //3.0
        oRequest.post5('project/v3/enterprise/rank', option).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
// 阅读排行
export const fetchViewRank = (option) => {
    return new Promise((resolve, reject) => {
        //2.0
        // oRequest.post5('project/index/enterpriserankview', option).then(res =>{
        //3.0
        oRequest.post5('project/v3/enterprise/enterpriseRankView', option).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}

// 评论分享排行
export const fetchShareRankC = (option) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/discuss/enterpriseRank', option).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
// 阅读大区排行
export const fetchViewRankRegion = (option) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/index/enterpriseRegionRankView', option).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
// 评论阅读大区排行
export const fetchViewRankComment = (option) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/discuss/enterpriseRegionRankView', option).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
// 评论阅读大区排行
export const fetchViewRankCommentOther = (option) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/discuss/enterpriseRankView', option).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
// 触达报表
export const getReachDataList = (option) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/v3/track/reachlist', option).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
// 触达报表
export const getTurnoverDataList = (option) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/v3/track/moalist', option).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}

/**
 * 获取筛选数据
 * @return {Promise<unknown>}
 */
export const fetchEnterpriseFilter = (tp5xcxuserid) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('praise/index/filtering', {tp5xcxuserid}).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
// 阅读数据的大区
export const fetchEnterpriseFilterView = (tp5xcxuserid) => {
    return new Promise((resolve, reject) => {
        oRequest.post5('project/index/region', {tp5xcxuserid}).then(res => {
            if (res.data.error === 0) {
                resolve(res.data.data);
            } else {
                Toast({
                    message: res.data.msg,
                    duration: 1200
                });
                reject(res.data.msg);
            }
        })
    })
}
